import { FaqCollapsedSection } from '@quicktools/shared-components';
import { Trans, useTranslation } from 'react-i18next';

function FaqSection() {
  const { t } = useTranslation();

  const faqQuestions = [0, 1, 2, 3].map((index) => ({
    question: t(`home.faqSection.questions.${index}.question`),
    answerSchema: t(`home.faqSection.questions.${index}.answer`),
    answer: (
      <Trans i18nKey={`home.faqSection.questions.${index}.answer`} components={{ a: <a /> }} />
    ),
  }));

  return (
    <FaqCollapsedSection
      title={t('home.faqSection.title')}
      description={<Trans i18nKey="home.faqSection.paragraph" components={{ a: <a /> }} />}
      questions={faqQuestions}
    />
  );
}

export default FaqSection;
